import { createRouter, createWebHashHistory } from "vue-router";
const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes: [
    {
      path: "/",
      name: "page",
      meta: { show: true },
      component: () => import("../components/PageIndex/index.vue"),
    },
    {
      path: "/homeIndex",
      name: "home",
      meta: { show: true },
      component: () => import("../components/Liuyao/HomeIndex/index.vue"),
    },
    {
      path: "/question",
      name: "question",
      meta: { show: true },
      component: () => import("../components/Liuyao/Question/index.vue"),
    },
    {
      path: "/shake",
      name: "shake",
      meta: { show: true },
      component: () => import("../components/Liuyao/Shake/index.vue"),
    },
    {
      path: "/handShake",
      name: "handShake",
      meta: { show: true },
      component: () => import("../components/Liuyao/HandShake/index.vue"),
    },
    {
      path: "/fixShake",
      name: "fixShake",
      meta: { show: true },
      component: () => import("../components/Liuyao/FixShake/index.vue"),
    },
    {
      path: "/answer",
      name: "answer",
      meta: { show: true },
      component: () => import("../components/Liuyao/Answer/index.vue"),
    },
    {
      path: "/mine",
      name: "mine",
      meta: { show: true },
      component: () => import("../components/Mine/index.vue"),
    },
    {
      path: "/history",
      name: "history",
      meta: { show: true },
      component: () => import("../components/History/index.vue"),
    },
    {
      path: "/order",
      name: "order",
      meta: { show: true },
      component: () => import("../components/Order/index.vue"),
    },
    {
      path: "/integral",
      name: "integral",
      meta: { show: true },
      component: () => import("../components/Liuyao/Integral/index.vue"),
    },
    {
      path: "/blank",
      name: "blank",
      meta: { show: true },
      component: () => import("../components/Liuyao/Blank/index.vue"),
    },
    {
      path: "/shareResult",
      name: "shareResult",
      meta: { show: true },
      component: () => import("../components/Liuyao/ShareResult/index.vue"),
    },
    {
      path: "/settings",
      name: "settings",
      meta: { show: true },
      component: () => import("../components/Settings/index.vue"),
    },
    {
      path: "/archiveList/:id?",
      name: "archiveList",
      meta: { show: false },
      component: () => import("../components/ArchiveList/index.vue"),
    },
    {
      path: "/archiveAdd",
      name: "archiveAdd",
      meta: { show: false },
      component: () => import("../components/ArchiveAdd/index.vue"),
    },
    {
      path: "/archives/addArchivesByShare",
      name: "addArchivesByShare",
      meta: { show: true },
      component: () => import("../components/ArchiveAdd/AddByShare/index.vue"),
    },
    {
      path: "/huangLi",
      name: "huangLi",
      meta: { show: true },
      component: () => import("../components/HuangLi/index.vue"),
    },
    {
      path: "/fateInfo/:id",
      name: "fateInfo",
      meta: { show: false },
      component: () => import("../components/FateInfo/index.vue"),
    },
    {
      path: "/mbtiAnalysisHomeIndex",
      name: "mbtiAnalysisHomeIndex",
      meta: { show: true },
      component: () => import("../components/MbtiAnalysis/HomeIndex/index.vue"),
    },
    {
      path: "/mbtiAnalysisQuestion",
      name: "mbtiAnalysisQuestion",
      meta: { show: true },
      component: () => import("../components/MbtiAnalysis/Question/index.vue"),
    },

    {
      path: "/mbtiAnalysisAnswer",
      name: "mbtiAnalysisAnswer",
      meta: { show: true },
      component: () => import("../components/MbtiAnalysis/Answer/index.vue"),
    },

    {
      path: "/mbtiAnalysisShareResult",
      name: "mbtiAnalysisShareResult",
      meta: { show: true },
      component: () =>
        import("../components/MbtiAnalysis/ShareResult/index.vue"),
    },
    {
      path: "/mbtiSocialHomeIndex",
      name: "mbtiSocialHomeIndex",
      meta: { show: true },
      component: () => import("../components/MbtiSocial/HomeIndex/index.vue"),
    },
    {
      path: "/mbtiSocialQuestion",
      name: "mbtiSocialQuestion",
      meta: { show: true },
      component: () => import("../components/MbtiSocial/Question/index.vue"),
    },

    {
      path: "/mbtiSocialAnswer",
      name: "mbtiSocialAnswer",
      meta: { show: true },
      component: () => import("../components/MbtiSocial/Answer/index.vue"),
    },

    {
      path: "/mbtiSocialShareResult",
      name: "mbtiSocialShareResult",
      meta: { show: true },
      component: () => import("../components/MbtiSocial/ShareResult/index.vue"),
    },
    {
      path: "/baziHomeIndex",
      name: "baziHomeIndex",
      meta: { show: true },
      component: () => import("../components/BaZi/HomeIndex/index.vue"),
    },
    {
      path: "/baziReport",
      name: "baziReport",
      meta: { show: true },
      component: () => import("../components/BaZi/BaZiReport/index.vue"),
    },
    {
      path: "/baziReportContent",
      name: "baziReportContent",
      meta: { show: true },
      component: () => import("../components/BaZi/BaZiReportContent/index.vue"),
    },
    {
      path: "/bazireportContentLoading",
      name: "bazireportContentLoading",
      meta: { show: true },
      component: () => import("../components/BaZi/BaZiReportContentLoading/index.vue"),
    },
    {
      path: "/chat",
      name: "chat",
      meta: { show: true },
      component: () => import("../components/Chat/index.vue"),
    },
    {
      path: "/chatHistory",
      name: "chatHistory",
      meta: { show: true },
      component: () => import("../views/chat/History.vue"),
    },
    {
      path: "/lovePhotoHomeIndex",
      name: "lovePhotoHomeIndex",
      meta: { show: true },
      component: () => import("../components/LovePhoto/HomeIndex/index.vue"),
    },
    {
      path: '/lovePhoto/lovePhotoContent',
      name: 'LovePhotoContent',
      component: () => import('../components/LovePhoto/LovePhotoContent/index.vue'),
      meta: {
        title: '桃花画像生成',
        show: true
      }
    },
    {
      path: '/lovePhoto/result',
      name: 'LovePhotoResult',
      component: () => import('../components/LovePhoto/Result/index.vue'),
      meta: {
        title: '桃花画像结果',
        show: true
      }
    },
    {
      path: '/lovePhoto/share',
      name: 'LovePhotoShare',
      component: () => import('../components/LovePhoto/Share/index.vue'),
      meta: {
        title: '桃花画像分享',
        show: true
      }
    },
    {
      path: "/baziHepanMain",
      name: "baziHepanMain",
      meta: { show: true },
      component: () => import("../components/BaziHepan/BaziHepanMain/index.vue"),
    },
    {
      path: "/baziHepanReport",
      name: "baziHepanReport",
      meta: { show: true },
      component: () => import("../components/BaziHepan/BaziHepanReport/index.vue"),
    },
    {
      path: "/hepan/share",
      name: "hepanShare",
      meta: { show: true },
      component: () => import("../components/BaziHepan/BaziHepanReportShare/index.vue"),
    },
    {
      path: "/hepan/simpleShare",
      name: "hepanSimpleShare",
      meta: { show: true },
      component: () => import("../components/BaziHepan/BaziHepanMainShare/index.vue"),
    },
    {
      path: "/qiMenDunJiaHomeIndex",
      name: "qiMenDunJiaHomeIndex",
      meta: { show: true },
      component: () => import("../components/QiMenDunJia/HomeIndex/index.vue"),
    },
    {
      path: "/qiMenDunJiaQuestion",
      name: "qiMenDunJiaQuestion",
      meta: { show: true },
      component: () => import("../components/QiMenDunJia/Question/index.vue"),
    },
    {
      path: "/qiMenDunJiaAnswer",
      name: "qiMenDunJiaAnswer",
      meta: { show: true },
      component: () => import("../components/QiMenDunJia/Answer/index.vue"),
    },
    {
      path: "/qimen/share",
      name: "qiMenDunJiaShare",
      meta: { show: true },
      component: () => import("../components/QiMenDunJia/Share/index.vue"),
    },
    {
      path: "/psychologyTest",
      name: "psychologyTest",
      meta: { show: true },
      component: () => import("../components/PsychologyTest/HomeIndex/index.vue"),
    },
    {
      path: "/psychologyTest/detail",
      name: "psychologyTestDetail",
      meta: { show: true },
      component: () => import("../components/PsychologyTest/ScaleDetail/index.vue"),
    },
    {
      path: "/psychologyTest/question",
      name: "psychologyTestQuestion",
      meta: { show: true },
      component: () => import("../components/PsychologyTest/TestQuestion/index.vue"),
    },
    {
      path: "/psychologyTest/result",
      name: "psychologyTestResult",
      meta: { show: true },
      component: () => import("../components/PsychologyTest/TestResult/index.vue"),
    },
    {
      path: "/scaleReport",
      name: "scaleReport",
      meta: { show: true },
      component: () => import("../components/PsychologyTest/ScaleReport/index.vue"),
    },
    {
      path: "/psychologyTestHistory",
      name: "psychologyTestHistory",
      meta: { show: true },
      component: () => import("../components/PsychologyTestHistory/index.vue"),
    },
    {
      path: "/psychologyTest/shareResult",
      name: "shareTestResult",
      meta: { show: true },
      component: () => import("../components/PsychologyTest/ShareTestResult/index.vue"),
    }
  ],
});

export default router;
